/**
 * SensitivityBadge — Fatia 8 + Fase C Brief 2A r7b DS canonical.
 *
 * Badge de nível de sensibilidade LGPD (1-4) usando DS v2.3.0 canonical
 * `.class-badge` + `.class-badge--n{2,3,4}` (components.css §7.3.1):
 *
 * - N1 (Pública): sem badge (retorna null).
 * - N2 (Restrita): bg-surface-2 + fg-2 + dot --sens-2 (cinza stone #A8A29E).
 * - N3 (Sensível): warning-bg + warning-fg + dot --sens-3 (amber #D97706).
 * - N4 (Crítica): danger-bg + danger-fg + dot --sens-4 (red #DC2626) + pulse.
 *
 * Spec §1.5 reinforce: N2 = cinza (--sens-2); N3 = amber (--sens-3).
 * (correção do legado N2=amber → DS canonical mapping).
 */
export function SensitivityBadge({ level }: { level: 1 | 2 | 3 | 4 | null }): JSX.Element | null {
  if (level === null || level === 1) return null;

  const labels: Record<2 | 3 | 4, string> = {
    2: 'Restrita',
    3: 'Sensível',
    4: 'Crítica',
  };

  // N4 (Crítica) ganha pulso adicional para atenção crítica.
  const pulseClass = level === 4 ? ' sensitivity-badge--pulse' : '';

  return (
    <span
      className={`class-badge class-badge--n${level}${pulseClass}`}
      title={`Sensibilidade LGPD Nível ${level.toString()} — ${labels[level]}`}
      aria-label={`Sensibilidade Nível ${level.toString()}`}
      data-testid="sensitivity-badge"
    >
      <span className="class-badge__dot" aria-hidden />
      <span>N{level}</span>
      <span aria-hidden>·</span>
      <span>{labels[level]}</span>
    </span>
  );
}
